import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import {
  formatCurrency,
  formatCurrencyFollowLocale,
} from '../../../helpers/value'
import { CURRENCY } from '../../../utils/currency'
import useGetExchangeRates from '../../category/useGetExchangeRates'
import { Element } from '../../html/element'
import { Image } from '../../image'
import { Tooltip } from '../../tooltip'
import currencyConversionIcon from './currencyConversion.svg'

export const CustomPrice = ({
  oldPrice,
  value,
  style,
  className,
  isShowIcon,
  styleIcon,
  exchangeRateAPI,
}) => {
  const { exchangeRates } = useGetExchangeRates()
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <div
      className={['dFlex alignItemsCenter justifyContentEnd', className].join(
        ' ',
      )}
    >
      {oldPrice && oldPrice !== value && (
        <Element
          className="whiteSpaceNowrap"
          style={{
            ...style,
            color: '#D5D5D5',
            fontWeight: 500,
            marginRight: 8,
            textDecorationLine: 'line-through',
          }}
        >
          {exchangeRateAPI
            ? formatCurrencyFollowLocale(
                oldPrice * (exchangeRateAPI || 0),
                CURRENCY.VND,
                locale,
              )
            : formatCurrency(
                oldPrice,
                CURRENCY.USD,
                CURRENCY.VND,
                exchangeRates,
                locale,
              )}
        </Element>
      )}
      <Element style={style} className="whiteSpaceNowrap">
        {exchangeRateAPI
          ? formatCurrencyFollowLocale(
              value * (exchangeRateAPI || 0),
              CURRENCY.VND,
              locale,
            )
          : formatCurrency(
              value,
              CURRENCY.USD,
              CURRENCY.VND,
              exchangeRates,
              locale,
            )}
      </Element>
      {isShowIcon && (
        <Tooltip
          zIndex={13}
          contentClass="dFlex"
          tooltipContent={formatCurrencyFollowLocale(
            value,
            CURRENCY.USD,
            locale,
          )}
        >
          <Image
            src={currencyConversionIcon}
            alt="currency conversion"
            style={{ width: 20, marginLeft: 4, ...styleIcon }}
          />
        </Tooltip>
      )}
    </div>
  )
}

CustomPrice.propTypes = {
  value: PropTypes.number.isRequired,
  oldPrice: PropTypes.number,
  style: PropTypes.object,
  className: PropTypes.string,
  isShowIcon: PropTypes.bool,
  styleIcon: PropTypes.object,
}

CustomPrice.defaultProps = {
  value: 0,
  style: {},
  className: '',
  isShowIcon: true,
  styleIcon: {},
}
